if(!__webpack_require__.federation){
	__webpack_require__.federation = {
		initOptions: {"name":"site_custom_federation","remotes":[],"shareStrategy":"version-first"},
		chunkMatcher: function(chunkId) {return 28957 != chunkId},
		rootOutputDir: "",
		initialConsumes: undefined,
		bundlerRuntimeOptions: {}
	};
}